

































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'

const MAX_WIDTH = '100%'
const MIN_WIDTH = '0'
const MAX_OPACITY = '0.7'
const MIN_OPACITY = '0'

@Component
export default class UserNameInput extends Vue {
  maxlength = 16

  placeholder = 'Username'

  opacity = MAX_OPACITY

  borderWidth = MIN_WIDTH

  inputText = ''

  isFocused = false

  isFetchDisabled = false

  @Prop({ default: '80px' })
  marginTop!: string

  @Prop({ default: '800px' })
  inputWidth!: string

  @Prop({ default: false })
  isFetching!: boolean

  focus() {
    const { input } = this.$refs

    if (input instanceof HTMLElement) {
      input.focus()
    }
  }

  get styles() {
    const { isFetchDisabled, opacity, borderWidth, marginTop, inputWidth } = this

    return {
      '--opacity': opacity,
      '--border-width': borderWidth,
      '--margin-top': marginTop,
      '--input-width': inputWidth,
      '--cursor': isFetchDisabled ? 'auto' : 'pointer',
      '--button-opacity': isFetchDisabled ? 0.3 : 1,
      '--button-pointer-events': isFetchDisabled ? 'none' : 'auto',
    }
  }

  onHover() {
    this.borderWidth = MAX_WIDTH
  }

  onMouseLeave() {
    const { isFocused } = this
    if (!isFocused) this.borderWidth = MIN_WIDTH
  }

  onFocus() {
    this.isFocused = true
    this.opacity = MIN_OPACITY
  }

  onBlur() {
    const { inputText } = this

    const matched = inputText.match(/^\S+/g)

    if (matched !== null && matched.length > 0) return

    this.isFocused = false
    this.opacity = MAX_OPACITY
    this.borderWidth = MIN_WIDTH
  }

  @Emit('input')
  emitInputText(text: string) {
    return text
  }

  onEnter() {
    const { inputText, isFetching, isFetchDisabled } = this

    if (isFetching || isFetchDisabled) return

    this.emitInputText(inputText)
  }

  @Watch('inputText', { immediate: true })
  watchInputText(newText: string) {
    const matched = newText.match(/^\w{3,16}$/g)

    this.isFetchDisabled = matched === null
  }
}
